import { getGlobals, getNewsArchive, getNewsArchivePaths } from "storyblok/api"
import cache from "storyblok/cache"
import NewsArticlesSection from "components/NewsArticlesSection"
import Meta from "components/Meta"
import { Crumb } from "components/Breadcrumbs"
import CTABanner from "components/DynamicComponent/atoms/CTABanner"
import richText from "utilities/richText"

export default function NewsArchive({ newsArticles, page, number, total, meta }) {
  return (
    <main>
      <Meta info={meta} />
      <nav aria-label="Breadcrumb" className="px-6 py-6">
        <ol className="mx-auto w-full max-w-screen-xl">
          <Crumb {...{ text: "Home", href: "/" }} />
          <Crumb {...{ text: "Latest News", href: "/news/page/1", last: true }} />
        </ol>
      </nav>
      <section className="px-6 pb-12">
        <div className="mx-auto w-full max-w-screen-xl">
          <h1 className="pb-4 font-medium text-teal-dark">{page?.heading}</h1>
          <div className="lg:max-w-3xl">{richText(page?.content)}</div>
        </div>
      </section>
      <NewsArticlesSection {...{ newsArticles, total, number }} />
      <CTABanner />
    </main>
  )
}

export async function getStaticProps({ params: { number = 1 } }) {
  const globals = await getGlobals()
  const page = await getNewsArchive()

  const { newsArticles, total } = cache.get(`news/page/${number}`)

  return {
    props: {
      number,
      newsArticles,
      total,
      page: page ?? null,
      meta: page?.twentysixty_seo ?? null,
      globals: globals ?? null,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getNewsArchivePaths(),
    fallback: false,
  }
}
